import { useToast } from 'containers/ToastManager'
import { useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation } from 'gqlTypes'

export const useCustomerUpdateIdentityProviderConfig = () => {
  const { showToast } = useToast()
  const [
    updateIdentityProviderConfig,
  ] = useUpdateWorkspaceCustomerSsoIdentityProviderConfigMutation({
    onCompleted: () => {
      showToast('Configuration was successfully saved', 'positive')
    },
    onError: 'show-toast',
  })

  return {
    uploadIdentityProviderConfig: async (
      customerId: string,
      file?: File
    ): Promise<void> => {
      await updateIdentityProviderConfig({
        variables: {
          customerId,
          metadata: file,
        },
      })
    },
  }
}
